import Form from './Form';
import List from './List';
import hoc from './hoc';
export default {
  Form: Form,
  List: List,
  hoc: hoc
};